import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteLayloConfigurationMutation = createMutationHook(
  CreatorIntegrationsApiClient.deleteLayloConfiguration,
  {
    mutationKey: ['deleteLayloConfiguration'],
  },
)
